/**
 * Generic multimap: a key which maps to multiple valuess.
 * The values is an array
 * -> when we query the data, we get it back in the same order
 * -> an array may contain duplicates, if same value is added multiple times
 *    (we could implement a Multiset class if we need a different kind of duplication handling)
 **/
export class Multimap {
    delegatee = new Map();
    get(key) {
        return this.delegatee.get(key) ?? [];
    }
    has(key, value) {
        const items = this.delegatee.get(key);
        if (items !== undefined) {
            return items.includes(value);
        }
        else {
            return false;
        }
    }
    add(key, value) {
        this.delegatee.set(key, this.get(key).concat(value));
    }
    addAll(key, values) {
        this.delegatee.set(key, this.get(key).concat(values));
    }
    remove(key, value) {
        const items = this.delegatee.get(key);
        if (items !== undefined) {
            const newItems = items.filter((i) => i !== value);
            if (newItems.length > 0) {
                this.delegatee.set(key, newItems);
            }
            else {
                this.delegatee.delete(key);
            }
        }
    }
    removeAll(key, values) {
        values.forEach((value) => this.remove(key, value));
    }
    *keys() {
        yield* this.delegatee.keys();
    }
    *values() {
        for (const k of this.keys()) {
            yield* this.get(k);
        }
    }
    getKeyCount() {
        return this.delegatee.size;
    }
    isEmpty() {
        return this.getKeyCount() === 0;
    }
}
